<header>
    <rendelo-menu></rendelo-menu>
</header>
<content>
    <router-outlet></router-outlet>
</content>
